module.exports = __WEBPACK_EXTERNAL_MODULE_65__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 65
// module chunks = 66 67